import {MutableRefObject} from 'react';
import {Dispatch} from 'redux';

export enum ArtworkType {
    Poster = 'poster',
    ThumbnailSmall = 'thumbnail_small',
    ThumbnailLarge = 'thumbnail_large',
    ThumbnailTiny = 'thumbnail_tiny',
    SeriesSquare = 'series_square',
    SeriesFeatured = 'series_featured',
}

export interface ArtworkItem {
    id: number;
    artworkType: ArtworkType;
    artworkUrl: string;
    fileSizeBytes: number;
    resX: number;
    resY: number;
    imageFormat: string;
    aspectRatio: any;
    url: string;
    status?: string;
    deliverable?: boolean;
}

export interface QCToolsArtworkState {
    artworkImages: ArtworkItem[];
    isLoading: boolean;
}

export enum AspRatio {
    tile = '0:0',
    small = '4:3',
    large = '16:9',
}

export enum ArtworkStatus {
    done = 'DONE',
    pending = 'PENDING',
    failed = 'FAILED',
    waiting = 'WAITING',
}

export type HandleQCArtwork = {
    id: number;
    qcId: string;
    setArtworksWait: Function;
    deleteArtwork: Function;
    retryArtwork: Function;
    dispatch: Dispatch;
    setModalVisible: Function;
};

export type Thumbnail =
    | ((instance: HTMLDivElement | null) => void)
    | MutableRefObject<HTMLDivElement | null>
    | null;

export type ThumbnailRefs = {current: {[key: string]: HTMLImageElement | null}};

export const DEBOUNCE_TIME = 700;

export const transformWrapperProps = {
    defaultScale: 1,
    pan: {
        disabled: false,
    },
    pinch: {
        disabled: true,
    },
    doubleClick: {
        disabled: true,
    },
    wheel: {
        step: 10,
    },
    options: {
        maxScale: 4,
        minScale: 1,
    },
    scalePadding: {
        size: 1,
    },
    zoomIn: {
        step: 12,
    },
    zoomOut: {
        step: 10.5,
    },
    defaultPositionX: 200,
    defaultPositionY: 100,
};
